module.exports = __webpack_public_path__ + "img/it_iron_2019_software_badge.b7194176.png";